export default function Hero() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20night%20city%20skyline%20at%20midnight%20with%20glowing%20golden%20window%20lights%2C%20one%20bright%20building%20standing%20out%2C%20peaceful%20urban%20landscape%2C%20starry%20night%20sky%2C%20soft%20dreamy%20atmosphere%2C%20atmospheric%20photography%2C%20cinematic%20lighting%2C%20warm%20amber%20and%20deep%20navy%20contrast&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="凌晨不打烊 24小时全天候服务"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <p className="text-primary-300 text-sm md:text-base font-medium tracking-widest mb-4 animate-[fadeInUp_0.8s_ease-out]">
            24 HOURS · 365 DAYS
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight animate-[fadeInUp_0.8s_ease-out_0.1s]">
            凌晨不打烊
            <span className="block text-2xl md:text-3xl lg:text-4xl mt-2 font-normal text-background-100">
              无论几点，都有人在
            </span>
          </h1>
          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed animate-[fadeInUp_0.8s_ease-out_0.2s]">
            深夜下单、凌晨咨询、随时响应。24小时不间断服务，让你每一个需要帮助的深夜都不孤单。
            真正做到凌晨不打烊，用心陪伴每一位用户。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-[fadeInUp_0.8s_ease-out_0.3s]">
            <a
              href="/categories"
              className="px-8 py-3.5 bg-primary-500 text-white rounded-full text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer shadow-[0_0_40px_rgba(255,140,50,0.3)]"
            >
              查看全部服务
            </a>
            <a
              href="/about#contact"
              className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-medium whitespace-nowrap hover:bg-white/20 transition-all cursor-pointer"
            >
              立即咨询
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}